// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isTagUsage = objectOf({
  campaigns_count: number,
  cards_count: number,
  engagement_reports_count: number,
  locations_count: number,
  name: string,
  segments_count: number,
  templates_count: number,
  workflows_count: number,
});
